import { HashLink } from 'react-router-hash-link';

const BackHome = () => {

  return (
    <section id="backList" className="section">
        <div className="container-fluid-small">
            <div className="row">
                <div className="col-12 back-list-btn-box anim-bot">

                  {/* リモートでは機能していない */}
                  <HashLink to="/#portfolioSection">HOME</HashLink>

                </div>
            </div>
        </div>
    </section>
  )
}
export default BackHome;